import { cadenceOf, daysSince } from "../lib/domain.js";

/* The cadence clock: days elapsed against this playground's own window,
   with a tick at the at-risk threshold, so a playground two days from
   slipping is visible before it slips. A playground with no review ever
   logged is drawn hatched rather than solid — "never reviewed" reads
   differently from a review that lapsed. */
export function Meter({ pg, tone }) {
  const c = cadenceOf(pg);
  const days = pg.lastMeetingAt ? daysSince(pg.lastMeetingAt) : null;
  const pct = days === null ? 100 : Math.min(100, (days / c.critical) * 100);
  const riskAt = (c.atRisk / c.critical) * 100;

  const left =
    days === null
      ? "No review logged"
      : days === 0
        ? "Reviewed today"
        : days + "d since review";
  const right =
    days === null ? c.label.toLowerCase() : c.label.toLowerCase() + " · " + c.atRisk + "d";

  return (
    <div className={"meter " + tone + (days === null ? " none" : "")}>
      <div className="track" role="img" aria-label={left}>
        <span className="fill" style={{ width: pct.toFixed(1) + "%" }} />
        <span className="tick" style={{ left: riskAt.toFixed(1) + "%" }} />
      </div>
      <div className="read">
        <span className="r">{left}</span>
        <span>{right}</span>
      </div>
    </div>
  );
}
